var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobile)?_c('big-screen'):_vm._e(),(_vm.isMobile)?_c('small-screen'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }